import { Component, inject } from '@angular/core';
import { TranslationService } from '../../../../shared/translations/services/translation.service';
import { SetupScreensService } from '../../services/setup-screens.service';
import { Alert, AlertService, AlertType } from '@michelin/theme';

@Component({
  selector: 'app-product-import',
  templateUrl: './product-import.component.html',
  styleUrl: './product-import.component.scss',
  standalone: false
})
export class ProductImportComponent {
  importResponse = '';
  isImporting = false;

  public translationService = inject(TranslationService);
  private setupScreensService = inject(SetupScreensService);
  public alertService = inject(AlertService);

  constructor() {}

  importProducts() {
    this.isImporting = true;
    this.setupScreensService.importProducts().subscribe({
      next: (value) => {
        this.isImporting = false;
        this.importResponse = value.data.response;
        this.alertService.showAlert({
          content: this.translationService.translate(this.importResponse),
          type: this.getImportAlertType(value.data.responseType)
        } as Alert);
      },
      error: (error) => {
        this.isImporting = false;
        console.log(error);
        this.alertService.showAlert({
          content: this.translationService.translate('criticalErrorAlertText'),
          type: AlertType.critical
        } as Alert);
      }
    });
  }

  private getImportAlertType(responseType: string): AlertType {
    if (responseType === '1') return AlertType.success;
    if (responseType === '2') return AlertType.strong;
    if (responseType === '3') return AlertType.critical;
    return AlertType.strong;
  }
}
